// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"06a59df637","253":"eb939f4a1d","619":"773b84a67e"}[chunkId] + ".js";
};